export default __webpack_public_path__ + "spin-868132c24fd83c61313bf4b16a5ed6c8.mp3";